<template>
  <v-dialog v-model="showBusinessHours" max-width="400px">
    <template #activator="{ on, attrs }">
      <button class="d-block position-relative w-100" v-on="on" v-bind="attrs">
        <p class="secondary--text font-weight-bold text-center">
          {{ $t('label.businessHours') }}
          <v-icon class="card-link-arrow">mdi-chevron-right</v-icon>
        </p>
      </button>
    </template>
    <v-card class="rounded-lg">
      <v-card-text class="text-center py-16">
        <table class="mx-auto">
          <tr>
            <th class="text-start text-subtitle-1 font-weight-bold" colspan="2">{{ $t('label.businessHours') }}</th>
          </tr>
          <tr v-for="businessHours in salonBusinessHours" :key="businessHours.day">
            <td class="business-hours--day text-start font-weight-medium">
              {{ businessHours.day }}
            </td>
            <td class="text-start font-weight-medium">{{ businessHours.hours }}</td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'businessHours'],
  data() {
    return {
      salonBusinessHours: []
    }
  },
  created() {
    this.salonBusinessHours = this.businessHours.map((businessHour) => {
      const split = businessHour.split(' ')
      const day = split.shift()
      const hours = split.join(' ')
      return { day, hours }
    })
  },
  computed: {
    showBusinessHours: {
      get() {
        return this.value
      },
      set(isOpen) {
        if (!isOpen) this.$emit('input', isOpen)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.business-hours--day {
  min-width: 4rem;
}
</style>
